import { Injectable } from '@angular/core';
import { QuotationLineItem } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class QuotationLineItemsService extends BaseService<QuotationLineItem> {
    constructor() {
        super('QuotationLineItem');
    }
}
